import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7hg48r9cec: FaireBrandEntity = {
  token: "b_7hg48r9cec",
  type: "brand",
  name: "Soak and Soothe Co",
  avatarUrl:
    "https://cdn.faire.com/fastly/24c236025a92f621bcc2eb3b84e51ebd5355a525a7bfd597ae5c7a8ee9ee9f68.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/4c1435b074f1373ed6e141b3a9caedce3e13dfc0dfe05c1d14a3a0e5f49719a3.png",
  logoUrl:
    "https://cdn.faire.com/fastly/24c236025a92f621bcc2eb3b84e51ebd5355a525a7bfd597ae5c7a8ee9ee9f68.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4c1435b074f1373ed6e141b3a9caedce3e13dfc0dfe05c1d14a3a0e5f49719a3.png",
  location: "Philadelphia, PA, USA",
  minimumOrderDollars: 150,
  rating: 0,
  reviewCount: 0,
  isInsider: false,
  description:
    "Welcome to Soak & Soothe Co! We're a mother and son duo who struggle with eczema - itchy, dry, cracked, bleeding skin - and we believe in making bath time a joyful and comforting experience, especially for those with sensitive skin. Our bath bombs are carefully crafted and handpressed, fragrance-free, dye-free, and glitter-free, making them perfect for delicate skin. Some bath bombs include a delightful toy surprise, making bath time a fun adventure for children and a relaxing ritual for adults.\n\nAfter our bath bombs were such a hit at local markets, we expanded into gentle and nourishing skincare. Our skin has never felt better and we're excited to share our products with children and adults alike.\n\nOur mission is to provide gentle bath care that nurtures the skin and soul. We are dedicated to small-batch production, ensuring quality and care in every fizz. Our values include providing safe, joyful bathing solutions that cater to sensitive skin needs.\n\nJoin us on our journey as we offer a rare opportunity for soothing bath solutions without the worry of harsh additives. With Soak & Soothe Co, experience a bath time that is both tranquil and joy-filled.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:59.031Z",
    importedBy: "entity-db-cli",
  },
};
